// IMPORTANT Autogenerated file
/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { RiepilogoProspettiDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class RiepilogoProspettiApiClient extends BaseCRUDApiClient<RiepilogoProspettiDto> {
  baseUrl = this.config.apiEndpoint + '/riepilogo-prospetti';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  calcolaRiepilogo() {
    this._pagedCache.clear();
    return this.http.get(this.baseUrl + '/calcola-riepilogo');
  }

  checkDatiRiepilogoModificati() {
    return this.http.get<boolean>(
      this.baseUrl + '/check-dati-riepilogo-modificati'
    );
  }
}
